import { Layout, Tabs } from '@arco-design/web-react';
import { useEditorProps } from '@bay-email/editor';
import React from 'react';
import { Blocks } from './Blocks';
import { BlockLayer } from '@extensions/BlockLayer';
import { FullHeightOverlayScrollbars } from '@extensions/components/FullHeightOverlayScrollbars';
import styles from './index.module.scss';
import { ConfigurationDrawer } from './ConfigurationDrawer';
import { useExtensionProps } from '@extensions/components/Providers/ExtensionProvider';
import { t } from '@bay-email/core';

const TabPane = Tabs.TabPane;

export function EditPanel({
  showSourceCode,
  jsonReadOnly,
  mjmlReadOnly,
}: {
  showSourceCode: boolean;
  jsonReadOnly: boolean;
  mjmlReadOnly: boolean;
}) {
  const { height } = useEditorProps();
  const { compact = true, showBlockLayer = true } = useExtensionProps();

  return (
    <Layout.Sider
      className={styles.blocksPanel}
      style={{ paddingRight: 0, minWidth: 360, height: '100%' }}
      // collapsed={collapsed}
      collapsible
      trigger={null}
      breakpoint='xl'
      collapsedWidth={60}
      width={360}
    >
      <Tabs
        defaultActiveTab='2'
        style={{ width: '100%', height: '100%', padding: 0 }}
        renderTabHeader={(_, DefaultHeader) => (
          <div className={styles.largeTabsHeader}>
            <DefaultHeader />
          </div>
        )}
      >
        <TabPane
          key='2'
          title={t('Content')}
          className='bg-25'
        >
          <FullHeightOverlayScrollbars height={`calc(100vh - 120px)`}>
            <Blocks />
          </FullHeightOverlayScrollbars>
        </TabPane>

        {showBlockLayer && (
          <TabPane
            key='1'
            title={t('Layers')}
          >
            <FullHeightOverlayScrollbars height={`calc(100vh - 120px)`}>
              <div style={{ padding: 20 }}>
                <BlockLayer />
              </div>
            </FullHeightOverlayScrollbars>
          </TabPane>
        )}
      </Tabs>
      {!compact && (
        <ConfigurationDrawer
          height={'100%'}
          showSourceCode={showSourceCode}
          compact={Boolean(compact)}
          jsonReadOnly={jsonReadOnly}
          mjmlReadOnly={mjmlReadOnly}
        />
      )}
    </Layout.Sider>
  );
}
